import React, { useState } from 'react';

const defaultValue = {
  etapa: '',
  uploading: false,
  loading: false,
  parametrosNotaFiscal: {},
  atualizarEtapa: false,
  conta: {},
  isTributado: false,
  steps: [
    { value: 'DADOS_CADASTRAIS', label: 'Dados cadastrais', pularEtapa: false },
    { value: 'LOGOMARCA', label: 'Logomarca', pularEtapa: false },
    { value: 'INFORMACOES_FISCAIS', label: 'Informações fiscais', pularEtapa: false },
    { value: 'CONTA_BANCARIA', label: 'Conta bancária', pularEtapa: false },
    { value: 'CERTIFICADO_DIGITAL', label: 'Certificado digital', pularEtapa: false },
  ],
};

export const OnboardingContext = React.createContext({});

export const OnboardingProvider = (props) => {
  return (
    <OnboardingContext.Provider
      value={{
        etapa: useState(defaultValue.etapa),
        uploading: useState(defaultValue.uploading),
        steps: useState(defaultValue.steps),
        loading: useState(defaultValue.loading),
        atualizarEtapa: useState(defaultValue.atualizarEtapa),
        parametrosNotaFiscal: useState(defaultValue.parametrosNotaFiscal),
        conta: useState(defaultValue.conta),
        isTributado: useState(defaultValue.isTributado)
      }}
    >
      {props.children}
    </OnboardingContext.Provider>
  );
};

export const OnboardingConsumer = OnboardingContext.Consumer;
